import { useQuery } from '@tanstack/react-query'

import { Filter } from 'components/FilterDrawer/FilterDrawer.config'
import { fetchFilterOptions } from 'services/verticalsTablesApi'

interface UseFilterOptionsQuery {
  verticalIndices: string
  currentQueryKey: string
  filtersInitialState: Filter[]
  entityId?: string
  entityIdField?: string
}

export const useFilterOptionsQuery = ({
  verticalIndices,
  currentQueryKey,
  filtersInitialState,
  entityId,
  entityIdField,
}: UseFilterOptionsQuery) => {
  const { data: filterOptions, isLoading } = useQuery({
    queryKey: [currentQueryKey, verticalIndices, filtersInitialState, entityId, entityIdField],
    queryFn: async () => {
      if (!verticalIndices) return null
      return await fetchFilterOptions(verticalIndices, filtersInitialState, entityId, entityIdField)
    },
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  return {
    filterOptions,
    isLoading,
  }
}
